import { render, staticRenderFns } from "./handel.vue?vue&type=template&id=831c83be"
import script from "./handel.vue?vue&type=script&lang=js"
export * from "./handel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports